import React from 'react';
import { Summary as OrderSummary } from '|/app/services';
import * as Summary from '|/app/steps/order-summary/order-summary-components.styles';
import useOrderSummaryVm from '|/helpers/use-order-summary';

const defaultProps = {
  summary: {} as OrderSummary
};

const CoBuyerDetailsSection = ({ summary } = defaultProps) => {
  const {
    isEligibleForCoApplicant,
    isCarvanaFinancing,
    isCoApplicantToggleOn,
    hasCoBuyerName,
    cobuyerName: name
  } = useOrderSummaryVm(summary);

  return (isEligibleForCoApplicant && isCarvanaFinancing) ||
    isCoApplicantToggleOn ? (
    <Summary.Section>
      <Summary.Heading>Co-signer</Summary.Heading>
      <Summary.Box>
        <Summary.List>
          <Summary.SummaryListItem
            label="Legal Name"
            value={hasCoBuyerName && isCoApplicantToggleOn ? name : 'Not Added'}
          />
        </Summary.List>
      </Summary.Box>
    </Summary.Section>
  ) : null;
};

export default CoBuyerDetailsSection;
